import { CulturesState } from './types'

export const DEFAULT_LANG = 'default'

export const initialState: CulturesState = {
  cultures: [],
  ready: false,
}
